import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/shared/constants/constants.constant';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { SecurityService } from 'src/app/core/services/security.service';

@Component({
	selector: 'app-record-not-found',
	templateUrl: './record-not-found.component.html',
	standalone: false,
})
export class RecordNotFoundComponent implements OnInit {
	constructor(
		private appContext: AppContextService,
		private securityService: SecurityService
	) {
		this.appContext.ViewTitle = 'Record not Found';
		this.appContext.BasePageCSSClass.set(Constants.BasePageCSSClass.Default);
	}
	ngOnInit(): void {
		this.securityService.updateCurrentUser(false).subscribe();
	}
}
